import React, { useState, useEffect } from "react";
import { Separator } from "../Headers/Separator";
import { CardLinea } from "./CardLinea";
import '../../styles/lineasInvestigacion.css'
import { Cita1 } from "../Citas/Cita1";
import { getDocs, collection, query, orderBy, where } from 'firebase/firestore/lite';
import { db } from '../../firebase';
import LINEAS_ACTUALES from '../../Json/LINEAS_ACTUALES.json'

export const LineasInvestigacion = (props) =>{
    const [researchLines, setResearchLines] = useState([]);
    const [, setSubLines] = useState([]);

    // Cargar líneas de investigación desde Firebase
    useEffect(() => {
        const fetchResearchLines = async () => {
            try {
                // Intentar con orderBy primero
                let querySnapshot;
                try {
                    const q = query(collection(db, "research-lines"), where("enabled", "==", true), orderBy('order'));
                    querySnapshot = await getDocs(q);
                } catch (orderError) {
                    // Si falla orderBy, obtener sin ordenar y ordenar manualmente
                    console.warn('Error con orderBy, obteniendo sin ordenar:', orderError);
                    const q = query(collection(db, "research-lines"), where("enabled", "==", true));
                    querySnapshot = await getDocs(q);
                }
                
                const newData = querySnapshot.docs
                    .map((doc) => ({ ...doc.data(), id:doc.id }))
                    // Asegurar que todos tengan un valor de order válido
                    .map((linea) => ({
                        ...linea,
                        order: linea.order !== undefined && linea.order !== null ? linea.order : 999
                    }))
                    // Ordenar siempre por el campo order
                    .sort((a, b) => {
                        const orderA = a.order !== undefined && a.order !== null ? a.order : 999;
                        const orderB = b.order !== undefined && b.order !== null ? b.order : 999;
                        return orderA - orderB;
                    });
                setResearchLines(newData);
            } catch (error) {
                console.error('Error fetching research lines:', error);
                // Fallback al JSON si hay error
                const lineasOrdenadas = [...LINEAS_ACTUALES]
                    .map((linea) => ({
                        ...linea,
                        order: linea.order !== undefined && linea.order !== null ? linea.order : 999
                    }))
                    .sort((a, b) => {
                        const orderA = a.order || 999;
                        const orderB = b.order || 999;
                        return orderA - orderB;
                    });
                setResearchLines(lineasOrdenadas);
            }
        };

        const fetchSubLines = async () => {
            try {
                const q = query(collection(db, "sub-research-lines"), where("enabled", "==", true), orderBy('orden'));
                const querySnapshot = await getDocs(q);
                const newData = querySnapshot.docs
                    .map((doc) => ({ ...doc.data(), id:doc.id }));
                setSubLines(newData);
            } catch (error) {
                console.error('Error fetching sub-lines:', error);
                setSubLines([]);
            }
        };

        fetchResearchLines();
        fetchSubLines();
    }, []);

    // Asegurar que las líneas estén ordenadas por el campo order
    const lineasOrdenadas = researchLines.length > 0 
        ? [...researchLines].sort((a, b) => {
            const orderA = a.order !== undefined && a.order !== null ? a.order : 999;
            const orderB = b.order !== undefined && b.order !== null ? b.order : 999;
            // Si tienen el mismo order, mantener el orden original
            if (orderA === orderB) {
                return 0;
            }
            return orderA - orderB;
        })
        : [];

    return(
        <section id="LineasInvestigacion" className="section">
            <Separator name="Líneas de investigación"></Separator>
            <Cita1 autor={'Leonardo da Vinci'} cita={'La Ciencia es el capitán y la práctica el soldado. La persona que se enamora de la práctica sin la Ciencia es como el navegante que quiere manejar su nave sin brújula ni timón y, por consiguiente, no sabe a dónde va.'} ></Cita1>
            <br />
            <div className="container">
                <div className="row gap-0 row-gap-3">

                    {lineasOrdenadas.map((elem) =>{
                        // Obtener las sub-líneas para esta línea
                       return(
                            <CardLinea 
                                {...props} 
                                key={elem.name} 
                                color={elem.color} 
                                icon={elem.icon} 
                                name={elem.name}
                                image={elem.image}
                            ></CardLinea>
                        )
                    })}


                </div>
            </div>
        </section>
    )
}